import { render } from "./InboundUpload.vue?vue&type=template&id=355f3ea9&scoped=true"
import script from "./InboundUpload.vue?vue&type=script&lang=js"
export * from "./InboundUpload.vue?vue&type=script&lang=js"

import "./InboundUpload.vue?vue&type=style&index=0&id=355f3ea9&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-355f3ea9"]])

export default __exports__